import { render, staticRenderFns } from "./Dialog_DistributionSecondHeadTeacher.vue?vue&type=template&id=6473b5d6&scoped=true&"
import script from "./Dialog_DistributionSecondHeadTeacher.vue?vue&type=script&lang=js&"
export * from "./Dialog_DistributionSecondHeadTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473b5d6",
  null
  
)

export default component.exports